import { render, staticRenderFns } from "./resumeBankDetails.vue?vue&type=template&id=c86349e6&scoped=true&"
import script from "./resumeBankDetails.vue?vue&type=script&lang=js&"
export * from "./resumeBankDetails.vue?vue&type=script&lang=js&"
import style0 from "./resumeBankDetails.vue?vue&type=style&index=0&id=c86349e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86349e6",
  null
  
)

export default component.exports